import React from 'react';
import { BrowserRouter as Router, Switch, Route, useLocation } from 'react-router-dom';
import TrainList from './TrainManagement/TrainList';
import UpdateTrain from './TrainManagement/UpdateTrain';
import ViewTrain from './TrainManagement/ViewTrain';
import AddTrain from './TrainManagement/AddTrain';
import AddReservation from './ReservationManagement/AddReservation';
import ReservationList from './ReservationManagement/ReservationList';
import ViewReservation from './ReservationManagement/ViewReservation';
import UpdateReservation from './ReservationManagement/UpdateReservation';
import SignIn from './UserManagement/SignIn';
import Signup from './UserManagement/SignUp';
import Home from './Home';
import Profile from '../Components/UserManagement/Profile';
import { UserProvider } from './UserContext';
import UpdateProfile from './UserManagement/UpdateProfile';
import TravelerUser from './UserManagement/BackOfficeUser/TravellerUser';
import TravellerList from './UserManagement/TravelAgent/TravellerList';
import UpdateTraveller from './UserManagement/TravelAgent/UpdateTraveller';
import ViewTraveller from './UserManagement/TravelAgent/ViewTraveller';
import AddTraveller from './UserManagement/TravelAgent/AddTraveller';
import Navbar from '../Components/NavBar';
import Footer from './Footer';
import BackOfficeUserHome from './BackOfficeUserHome';
import TravelAgentHome from './TravelAgentHome';

const AppRouter = () => {
  const location = useLocation();

  const hideNavbarRoutes = ['/', '/signup'];
  const hideFooterRoutes = ['/', '/signup'];

  const shouldHideNavbar = hideNavbarRoutes.includes(location.pathname);
  const shouldHideFooter = hideFooterRoutes.includes(location.pathname);

  return (
    <Router>
      <UserProvider>
        {!shouldHideNavbar && <Navbar />}
        <Switch>
          <Route path="/listtrain" exact component={TrainList} />
          <Route path="/view/:trainID" component={ViewTrain} />
          <Route path="/update/:trainID" component={UpdateTrain} />
          <Route path="/addtrain" component={AddTrain}/>
          <Route path="/listreservation" component={ReservationList}/>
          <Route path="/makereservation" component={AddReservation}/>
          <Route path="/reservationview/:reservationID" component={ViewReservation} />
          <Route path="/reservationupdate/:reservationID" component={UpdateReservation} />
          <Route path="/profile/:userId" component={Profile} />
          <Route path="/home" component={Home} />
          <Route path="/signup" exact component={Signup} />
          <Route path="/" exact component={SignIn} />
          <Route path="/updateprofile/:userId" component={UpdateProfile} />
          <Route path="/traveluserstatus" component={TravelerUser} />
          <Route path="/listtraveluser" component={TravellerList} />
          <Route path="/updatetraveller/:userId" component={UpdateTraveller} />
          <Route path="/viewtraveller/:userId" component={ViewTraveller} />
          <Route path="/addtraveluser" component={AddTraveller} />
          <Route path="/backofficeuserdashboard" component={BackOfficeUserHome} />
          <Route path="/travelagentdashboard" component={TravelAgentHome} />
          <Route path="/footer" component={Footer} />
        </Switch>
        {!shouldHideFooter && <Footer />}
      </UserProvider>
    </Router>
  );
};

export default AppRouter;